import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { Home, Phone, MapPin } from 'lucide-react';
import { Button } from '../components/ui/button';
import { COMPANY } from '../data/mock';
import { resolveLegacyPath } from '../lib/legacyRedirects';

const NotFound = () => {
  const location = useLocation();
  const target = resolveLegacyPath(location.pathname);

  // Old link -> send visitor to the matching new page
  if (target && target !== location.pathname) {
    return <Navigate to={target} replace />;
  }

  return (
    <section className="min-h-[70vh] flex items-center brand-gradient">
      <div className="max-w-2xl mx-auto px-5 lg:px-8 py-20 text-center">
        <div className="text-7xl font-extrabold font-display text-brand">404</div>
        <h1 className="mt-4 text-3xl lg:text-4xl font-bold text-[#13251b]">Page not found</h1>
        <p className="mt-4 text-[#44564b]">
          The page you’re looking for may have moved. Try one of these instead:
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Button asChild className="bg-brand hover:bg-[#5c9a22] text-white rounded-full px-7 h-12 font-semibold">
            <Link to="/"><Home className="h-4 w-4 mr-1" /> Home</Link>
          </Button>
          <Button asChild variant="outline" className="rounded-full px-7 h-12 font-semibold border-[#cbdcbb] text-[#13251b]">
            <Link to="/service-areas"><MapPin className="h-4 w-4 mr-1" /> Service Areas</Link>
          </Button>
          <Button asChild variant="outline" className="rounded-full px-7 h-12 font-semibold border-[#cbdcbb] text-[#13251b]">
            <a href={COMPANY.phoneHref}><Phone className="h-4 w-4 mr-1" /> {COMPANY.phone}</a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
